module.exports = __webpack_public_path__ + "img/yl-a.42a7f9f3.jpg";